import '../scss/mailchimp.scss';

// Delegated submit: a single document-level listener handles every Mailchimp
// form, including those injected after initial parse (modals, Elementor popups,
// AJAX). Binding per-form at load missed forms that only exist inside a modal,
// so the browser fell through to a native GET submit and navigated away.
document.addEventListener('submit', async (event) => {
	const form = event.target.closest('[data-jkd-mailchimp-form]');
	if (!form) return;

	// Always stop the native submit first, even if the config is missing, so the
	// page never navigates to the form action with the fields in the URL.
	event.preventDefault();
	if (!window.jkdmc) return;

	const message = form.querySelector('[data-jkd-mailchimp-message]');
	const button = form.querySelector('button[type="submit"]');
	const data = new FormData(form);
	data.append('action', 'jkdmc_subscribe');
	data.append('nonce', window.jkdmc.nonce);

	if (button) {
		button.disabled = true;
		button.classList.add('is-loading');
	}
	if (message) message.hidden = true;

	try {
		const response = await fetch(window.jkdmc.ajaxUrl, {
			method: 'POST',
			credentials: 'same-origin',
			body: data,
		});
		const payload = await response.json();
		if (message) {
			// The server already returns visitor-safe copy in `message`; raw
			// Mailchimp API detail is never sent to the client.
			const info = payload?.data || {};
			message.textContent = info.message || '';
			message.dataset.state = payload.success ? 'success' : 'error';
			message.hidden = false;
		}
		if (payload.success) form.reset();
	} catch (error) {
		if (message) {
			message.textContent = window.jkdmc.errorMessage;
			message.dataset.state = 'error';
			message.hidden = false;
		}
	} finally {
		if (button) {
			button.disabled = false;
			button.classList.remove('is-loading');
		}
	}
});
